import {NgModule, Injectable} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormsModule} from '@angular/forms';
import {RouterModule, Routes, CanActivate, Router, ActivatedRouteSnapshot, RouterStateSnapshot} from '@angular/router';

import { MatSidenavModule } from '@angular/material';
import { AppBaseComponent, HomeComponent, XsDebugComponent, XsPanelComponent, XsPanelItemsComponent } from './app.component';
import { Vasat } from 'vasat';
import { KeyboardService } from '../v2/commons/keyboard.service';
import { TreeNodeBuilder } from '../v2/commons/files/tree-events';

import {FourDService} from '4d-mapper';

@Injectable()
export class LoginNeeded implements CanActivate {
  constructor(protected V: Vasat, protected r: Router) {}
  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    if (this.V.localSession()) return true
    else {
      this.r.navigate(['/auth'], {queryParams: {prevpage: state.url, msg: 'Login Timed out'}})
      return false
    }
  }
}

let currentTeam = 'test';


const Routes: Routes = [
  { path: '', redirectTo:currentTeam, pathMatch: 'full' },
  { path: ':team', component:AppBaseComponent,
    children:[
      { path: '**', component:HomeComponent },
    ]
  }
];

@NgModule({
  imports: [
    FormsModule,
    CommonModule,
    MatSidenavModule,
    RouterModule.forChild(Routes)
  ],
  declarations:[
    AppBaseComponent, HomeComponent, XsPanelComponent, XsPanelItemsComponent, XsDebugComponent
  ],
  providers:[
    LoginNeeded, KeyboardService, TreeNodeBuilder
  ],
  entryComponents: []

})

export class Ver5Module {


}


